import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getRoles = async () => {
  const url = `${APIEndpoint.GET_ROLE_API}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getEStates = async () => {
  const url = `${APIEndpoint.GET_ESTATE_API}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getLineOfWork = async () => {
  const url = `${APIEndpoint.GET_LINE_OF_WORK_API}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const initAuthorizeRole = async () => {
  const api = APIEndpoint.INIT_AUTHORIZE_ROLE_MANAGEMENT_API;
  const res = await axiosInstance.get(api);
  return res;
};

export const createRole = async (payload) => {
  const api = APIEndpoint.CREATE_ROLE_MANAGEMENT_API;
  const res = await axiosInstance.post(api, JSON.stringify(payload));
  return res;
};
